import { NgIf } from '@angular/common';
import { Component, Inject, inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BarcodeFormat } from '@zxing/browser';
import { ZXingScannerComponent, ZXingScannerModule } from '@zxing/ngx-scanner';
import dayjs from 'dayjs';
import { catchError, EMPTY } from 'rxjs';
import { growVerticallyAnimation } from '../../../../animations/grow.animation';
import { RequestStateEnum } from '../../../../enums/app.enum';
import { DayjsFormatPipe } from '../../../../pipes/date.pipe';
import { CheckInService } from '../../../../services/check-in.service';
import { ModalService } from '../../../../services/modal.service';
import { ToastService } from '../../../../services/toast.service';
import { TodaysActivityStore } from '../../../../stores/today-activities.store';
import { getActivityTypeLabel, getDate } from '../../../../utilities/pure-functions';
import { SpinnerComponent } from '../../../atoms/spinner/spinner.component';
import { ModalHeaderComponent } from '../../../molecules/modal/modal-header/modal-header.component';
import { Activity } from '../../activities/activities.types';
import { ToastTypeEnum } from '../../toast/toast.type';

@Component({
  animations: [growVerticallyAnimation],
  selector: 'app-modal-scan-qr-code',
  templateUrl: './modal-scan-qr-code.component.html',
  imports: [ModalHeaderComponent, NgIf, SpinnerComponent, ZXingScannerModule, DayjsFormatPipe],
})
export class ModalScanQrCodeComponent implements OnInit {
  private readonly checkInService = inject(CheckInService);
  private readonly modalService = inject(ModalService);
  private readonly toastService = inject(ToastService);
  private readonly todaysActivityStore = inject(TodaysActivityStore);

  public activityTypeLabel: string;
  public allowedFormats = [BarcodeFormat.QR_CODE];
  public isLoading = true;
  public requestState: RequestStateEnum | null = null;
  static readonly overlayDataType: { activity: Activity };
  public animationDuration: number | undefined = undefined;

  @ViewChild(ZXingScannerComponent)
  public zXingScannerComponent: ZXingScannerComponent = new ZXingScannerComponent();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: typeof ModalScanQrCodeComponent.overlayDataType
  ) {
    this.activityTypeLabel = getActivityTypeLabel[this.data.activity.type];
  }

  ngOnInit() {
    if (getDate(this.data.activity.scheduledDate).isBefore(dayjs(), 'date')) {
      this.modalService.close();
    }
  }

  public checkIn(checkInCode: string): void {
    this.requestState = RequestStateEnum.PENDING;

    this.checkInService
      .createCheckIn(this.data.activity.id, checkInCode)
      .pipe(
        catchError(() => {
          this.toastService.addToast('Check-In fehlgeschlagen.', ToastTypeEnum.ERROR);
          this.todaysActivityStore.load();
          this.close();
          return EMPTY;
        })
      )
      .subscribe(() => {
        this.requestState = RequestStateEnum.SUCCESS;
        this.toastService.addToast('Check-In erfolgreich.', ToastTypeEnum.SUCCESS);
        this.todaysActivityStore.load();
        this.modalService.close();
      });
  }

  public close(): void {
    this.modalService.close();
  }

  protected readonly RequestStateEnum = RequestStateEnum;
}
